<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m4.82227 21.2008v-7.75c0-.5.15833-.9125.475-1.2375.31666-.325.725-.4875 1.225-.4875h1.45v-2.10002h-1.45c-.5 0-.90834-.1625-1.225-.4875-.31667-.325-.475-.7375-.475-1.2375v-3.4c0-.48333.15833-.8875.475-1.2125.31666-.325.725-.4875 1.225-.4875h10.95003c.5 0 .9083.1625 1.225.4875.3166.325.475.72917.475 1.2125v3.4c0 .5-.1584.9125-.475 1.2375-.3167.325-.725.4875-1.225.4875h-1.45v2.10002h1.45c.5 0 .9083.1625 1.225.4875.3166.325.475.7375.475 1.2375v7.75h-1.7v-2.975h-10.95003v2.975zm1.7-13.30002h10.95003v-3.4h-10.95003zm2.95 3.82502h5.05003v-2.10002h-5.05003zm-2.95 4.8h10.95003v-3.075h-10.95003z"
    />
  </svg>
</template>
